<template>
    <div>
        <div class="pb-10 max-w-465">
            <h2 class="mb-30">Create User</h2>

            <form-wrapper :validator="$v.user">

                <form-group name="first_name" label="First name" class="mb-14">
                    <input
                        @input="delayTouch($v.user.first_name)"
                        class="max-w-2/3"
                        slot-scope="{attributes}"
                        v-model="user.first_name"
                        v-bind="attributes"
                        type="text"
                        placeholder="Enter first name..."
                    >
                </form-group>

                <form-group name="last_name" label="Last name" class="mb-14">
                    <input
                        @input="delayTouch($v.user.last_name)"
                        class="max-w-2/3"
                        slot-scope="{attributes}"
                        v-model="user.last_name"
                        v-bind="attributes"
                        type="text"
                        placeholder="Enter last name..."
                    >
                </form-group>

                <form-group name="email" label="Email" class="mb-14">
                    <input
                        @input="delayTouch($v.user.email)"
                        class="max-w-2/3"
                        slot-scope="{attributes}"
                        v-model="user.email"
                        v-bind="attributes"
                        type="text"
                        placeholder="Enter email..."
                    >
                </form-group>

                <form-group name="position" label="Position" class="mb-14">
                    <input
                        @input="delayTouch($v.user.position)"
                        class="max-w-2/3"
                        slot-scope="{attributes}"
                        v-model="user.position"
                        v-bind="attributes"
                        type="text"
                        placeholder="Enter position..."
                    >
                </form-group>

                <h4 class="pb-8 font-bold text-16 pt-14">Their dashboard access...</h4>

                <div v-for="(client, index) in $v.user.clients.$each.$iter" :key="client.name" class="flex flex-wrap items-center mb-14">
                    <form-group :name="`clients.$each.${index}.client`" class="w-full pr-0 mb-8 md:w-2/3 md:pr-16 md:mb-0">
                        <multiselect
                            :allow-empty="false"
                            :options="filteredClients"
                            :searchable="true"
                            :show-labels="false"
                            label="name"
                            placeholder="Select client..."
                            track-by="id"
                            v-model="client.$model.client"
                        ></multiselect>
                    </form-group>
                    <div class="flex w-full md:w-1/3">
                        <label class="inline-flex items-center mr-16 cursor-pointer">
                            <input v-model="client.$model.default" @change="onChangeDefaultClient(client.$model)" :value="true" type="radio" name="defaultClient">
                            <span class="flex ml-8 text-white">Default</span>
                        </label>

                        <label class="inline-flex items-center mr-16 cursor-pointer">
                            <input v-model="client.$model.role" true-value="admin" false-value="user" type="checkbox">
                            <span class="ml-8">Admin</span>
                        </label>
                        <div v-if="canRemoveClient(client.$model)" @click="onRemoveClient(index)" class="flex items-center justify-center h-full px-10 cursor-pointer">
                            <svg class="w-18 h-18 fill-blue-light hover:fill-coral" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/></svg>
                        </div>
                        <div v-else class="flex items-center justify-center h-full px-10">
                            <svg class="w-18 h-18 fill-blue-dark" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/></svg>
                        </div>
                    </div>
                </div>

                <div v-if="canAddClient" class="flex justify-start mb-14">
                    <a @click="onAddClient">
                        + add client
                    </a>
                </div>

                <h4 class="pb-8 font-bold text-16 pt-14">Company Logo</h4>

                <div class="w-full">
                    <button @click="onSelectImage" class="w-full mb-14">
                        <span v-if="imageSrc">Change image</span>
                        <span v-else>Select image</span>
                        <input ref="fileInput" @input="setImage" type="file" name="image" accept="image/*" class="hidden" />
                    </button>

                    <template v-if="imageSrc">
                        <vue-cropper
                            :auto-crop-area="1"
                            :guides="true"
                            :src="imageSrc"
                            class="w-full mr-2 mb-14"
                            ref="cropper"
                        ></vue-cropper>

                        <button @click="cropImage" class="w-full mb-14">Crop image</button>

                        <!-- Cropped image previewer -->
                        <img :src="imageCroppedSrc" class="w-full mb-14"/>
                    </template>

                </div>

            </form-wrapper>

            <div v-if="errors" class="flex flex-col px-6 pt-6 pb-4 my-6 bg-red-700">
                <span v-for="error in errors" :key="error" class="mb-2 text-white">
                    {{error[0]}}
                </span>
            </div>
        </div>

        <div class="flex justify-end max-w-465 mb-30">
            <button @click="onCreate" :disabled="!canCreate" class="ml-4">
                <span v-if="creating">Creating...</span>
                <span v-else>Create</span>
            </button>
        </div>
    </div>
</template>

<script>
    import { between, email, integer, maxLength, minLength, required, sameAs } from "vuelidate/lib/validators"
    import { call, get, sync } from 'vuex-pathify'
    import imageUploadMixin from "../../mixins/imageUpload"
    import Multiselect from "vue-multiselect"
    import validationMixin from "../../mixins/validation"

    export default {
        props: {
            clientId: {
                type: Number,
            },
        },

        mixins: [
            imageUploadMixin,
            validationMixin
        ],

        components: {
            Multiselect,
        },

        data() {
            return {
                errors: null,
            }
        },

        computed: {
            user: sync('users/user'),
            creating: sync('users/creating'),
            clients: get('clients/clients'),

            canAddClient() {
                let filteredClientsLength = this.filteredClients.length > 0
                let hasNullClient = this.user.clients.find(client => client.client === null)

                return filteredClientsLength && !hasNullClient
            },

            canCreate() {
                if (!this.$v.$dirty) {
                    return !this.creating
                }

                return !this.$v.$invalid && !this.creating
            },

            filteredClients() {
                return this.clients.filter(client => {
                    return !this.user.clients.find(c => c.client === client)
                })
            },
        },

        async mounted() {
            await this.loadClients()
            this.getUser()
        },

        methods: {
            create: call('users/create'),
            loadClients: call('clients/loadClients'),
            reset: call('users/resetUser'),
            updateAvatar: call('users/updateAvatar'),

            canRemoveClient(client) {
                if (client.default) {
                    return false
                }

                return this.user.clients.length > 1
            },

            close() {
                window.location.href = `/admin/users`
            },

            getUser() {
                let default_client = null

                if (this.clientId) {
                    default_client = this.clients.find(client => client.id === this.clientId)
                }

                this.user.clients.push({
                    client: default_client,
                    default: true,
                    role: 'user',
                })
            },

            onAddClient() {
                this.user.clients.push({
                    client: null,
                    default: false,
                    role: 'user',
                })
            },

            onChangeDefaultClient(client) {
                this.user.clients.map(c => c.default = false)

                client.default = true
            },

            async onCreate() {
                if (! this.$v.$invalid) {
                    try {
                        let user = await this.create(this.user)

                        if (this.imageCroppedSrc) {
                            await this.uploadImage(user)
                        }

                        this.close()
                        this.$emit('create')
                    } catch (error) {
                        this.errors = error.response.data.errors

                        this.$v.$reset()
                    }

                    this.creating = false
                } else {
                    this.$v.$touch();
                }
            },

            onRemoveClient(index) {
                this.user.clients.splice(index, 1)
            },

            async updateImage(formData) {
                return await this.updateAvatar(formData)
            }
        },

        validations: {
            user: {
                first_name: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(255)
                },

                last_name: {
                    minLength: minLength(2),
                    maxLength: maxLength(255)
                },

                position: {
                    minLength: minLength(3),
                    maxLength: maxLength(255)
                },

                email: {
                    required,
                    email
                },

                clients: {
                    required,
                    $each: {
                        client: {
                            required,
                        }
                    }
                }
            }
        },

        beforeDestroy() {
            this.close()
        },
    }
</script>
